import { render, staticRenderFns } from "./PressButton.vue?vue&type=template&id=63ae8019&scoped=true&"
import script from "./PressButton.vue?vue&type=script&lang=ts&"
export * from "./PressButton.vue?vue&type=script&lang=ts&"
import style0 from "./PressButton.vue?vue&type=style&index=0&id=63ae8019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae8019",
  null
  
)

export default component.exports